import { iosSteps } from "@/constants";
import React from "react";

const Ios = () => {
  return (
    <div className="mx-auto mt-10 flex max-w-6xl flex-col gap-20 lg:mt-10 lg:gap-32">
      {iosSteps.map((step, index) => (
        <div
          key={index}
          className={`flex w-full items-center justify-center gap-2 ${
            index % 2 === 0
              ? "flex-col-reverse lg:flex-row"
              : "flex-col-reverse lg:flex-row-reverse"
          }`}
        >
          <div className="flex flex-col lg:w-1/2">
            <h1 className="text-[59px] leading-[1] font-semibold text-[#DDDD] lg:text-[85px]">
              0{index + 1}
            </h1>

            <h2 className="pt-2 pb-5 text-[19.2px] leading-[1.1] font-medium text-[#333] lg:text-[33px]">
              {step.title}
            </h2>

            <p className="font-geist text-[14.4px] text-[#555] lg:text-lg">
              {step.details}
            </p>
          </div>

          <div className="step-img-box lg:w-1/2">
            <img
              src={step.image}
              alt={`${index + 1}-image`}
              className="w-[35%] md:w-[40%]"
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Ios;
